import {IIconProps} from '@fluentui/react';
import {borderColor} from '../../styles';

export function buildIconPropsForTextField(iconName: string): IIconProps {
  return {
    iconName: iconName,
    styles: {
      root: {
        fontSize: 20,
        color: borderColor,
        top: 6,
        right: 4,
      },
    },
  };
}
